import React, { useEffect, useState } from "react";
import DOMPurify from "dompurify";
import { api } from "../api";

export default function LegalPage({ slug }) {
    const [page, setPage] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setLoading(true);
        api.get(`/pages/${slug}`)
            .then((r) => setPage(r.data))
            .catch(() => setPage(null))
            .finally(() => setLoading(false));
    }, [slug]);

    return (
        <div className="max-w-[880px] mx-auto px-6 py-14" data-testid={`legal-page-${slug}`}>
            <div className="text-center mb-10">
                <p className="eyebrow">UCare Essentials</p>
                <h1 className="h-display text-[34px] sm:text-[48px] mt-3" data-testid="legal-page-title">
                    {page?.title || (loading ? "…" : "Page")}
                </h1>
                {page?.updated_at && (
                    <p className="text-[12px] text-[var(--body)] mt-3">
                        Last updated: {new Date(page.updated_at).toLocaleDateString("en-IN", { year: "numeric", month: "long", day: "numeric" })}
                    </p>
                )}
            </div>

            <div className="card-glass p-6 sm:p-10" style={{ borderRadius: 20 }}>
                {loading ? (
                    <div className="space-y-3 animate-pulse">
                        {[...Array(6)].map((_, i) => <div key={i} className="h-4 bg-[var(--bg-alt)] rounded w-full" style={{ width: `${90 - i * 8}%` }} />)}
                    </div>
                ) : page?.body ? (
                    <div className="prose-ucare" data-testid="legal-page-body" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(page.body) }} />
                ) : (
                    <p className="text-[var(--body)] text-center py-8" data-testid="legal-page-empty">
                        This page is being prepared. Please check back soon or contact us at hello@ucareessentials.com.
                    </p>
                )}
            </div>
        </div>
    );
}
